module.exports = __webpack_public_path__ + "static/media/ldi-header.2ab51e85.jpg";